var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/swagger-client/~/lodash/_Symbol.js
// module id = 158
// module chunks = 0